<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";

export default {
  page: {
    title: "Firme",
  },
  components: {PageHeader, Layout},
  props: {
  },
  data() {
    return {
      title: 'Firme',
      currentPage: 1,
      perPage: 15,
      sortBy: 'client.status',
      sortDesc: true,
      fields: [
        {key: 'company_name', label: 'Ime', sortable: false},
        {key: 'user.email', label: 'Email', sortable: false},
        {key: 'limit', sortable: false},
        {key: 'partner_id', sortable: false},
        {key: 'is_ariba_enabled', label: 'Ariba', sortable: false},
        {key: 'order_status', label: "Stanje pordudžbenica", sortable: false},
      ],
      administrators: [],
      filter: 'All',
      searchText: ''
    }
  },
  computed: {

  },
  async created() {
    this.$store.commit('loader/START_LOADING');

    try {
      const {data} = await axios.get('/super-admin/administrators');
      this.administrators = data;

    } catch (e) {
      // eslint-disable-next-line no-empty
    } finally {
      this.$store.commit('loader/END_LOADING');
    }
  },
  methods: {
    showAdministrator(administrator) {
      this.$router.push(`/super-admin/administrators/${administrator.id}/edit`)
    },
    createNewAdministrator() {
      this.$router.push(`/super-admin/administrators/create`)
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title"/>
    <div class="row mb-2">
      <div class="col-12 col-md-12 d-flex align-items-end justify-content-end">
        <b-button @click="createNewAdministrator" variant="primary">Nova firma</b-button>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <b-table :items="administrators" :fields="fields" striped responsive
                 class="border-left border-right border-bottom"
                 selectable
                 @row-clicked="showAdministrator"
        >
          <template v-slot:cell(is_ariba_enabled)="data">
            <div>
              <div :style="{ 
                width: '15px', 
                height: '15px', 
                backgroundColor: data.item.is_ariba_enabled ? 'green' : 'gray', 
                borderRadius: '50%', 
                border: '2px solid #fff', 
                boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)', 
                margin: 'auto' 
              }">
              </div>
            </div>
          </template>
          <template v-slot:cell(order_status)="data">
            <div>
              <div :style="{ 
                width: '15px', 
                height: '15px', 
                  backgroundColor: !data.item.has_order_forms ? '' : 
                            (data.item.status === 'ALLOW_ORDERING' ? 'green' : 
                            (data.item.status === 'DISALLOW_ORDERING' ? 'orange' : 
                            (data.item.status === 'SOFT_ORDERED' ? 'red' : 'red'))), 
                  borderRadius: '50%', 
                  border: '2px solid #fff', 
                  boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)', 
                  margin: 'auto' 
                }">
                </div>
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
  .search-box .form-control {
    border-radius: 0.25rem;
  }
</style>
